
import Vue from "vue";
import AppCreateUblArchiveModalWrapper from "./CreateUblArchiveModalWrapper.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import AppMultiSelectJournal from "@/components/MultiSelectJournal.vue";

export default Vue.extend({
	data(){
		return {
			journalIds: [1],
			beginDate: new Date(new Date().getFullYear(), 0, 1),
			endDate: new Date(new Date().getFullYear(), 11, 31),
			vatPeriod: new Date().getMonth()+1,
			message: "",
			settings: DossierConfigService.getPluginConfig()
		};
	},
	props: {
		isPurchase: Boolean,
	},
	computed: {
		filterOnVatPeriod(): Boolean{
			return this.isPurchase && (this.settings as any).UBL.FilterPurchasesOnVatPeriod;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		create(){
			let vatPeriod = this.vatPeriod;
			if (!this.filterOnVatPeriod){
				vatPeriod = 0;
			}
			this.$emit("create", {beginDate: this.beginDate, endDate: this.endDate, message: this.message, vatPeriod, journals: this.journalIds});
		}
	},
	components: {
		AppCreateUblArchiveModalWrapper,
		AppMultiSelectJournal
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
